<template>
    <div>
        <p class="headCard" v-if="listData.length" v-for="(i,ind) in listData">
            <span :style="{'width':width,'height':height}" class="hex">
                <span class="hexIn">
                    <img v-if="i.avatar" :src="i.avatar" alt="">
                    <img class="playerHead" v-else src="../assets/img/updateImg/playerHead.png" alt="">
                </span>
            </span>
            <span class="nameMsg overText">
                <i class="num akrobatBold">{{i.number}}</i>
                <i class="name PingFang">{{i.name}}</i>
            </span>
        </p>

    </div>
</template>

<script>
    export default {
        name: "photoAndMsgCard",
        props: {
            listData: Array,
            width: String,
            height: String,
            color: String
        }
    }
</script>

<style scoped lang="less">
    .headCard{
        display: inline-block;
    }
    .hex {
        overflow: hidden;
        display: inline-block;
        width: 7vw;
        height: 8vw;
        transform: rotate(-60deg) skewY(30deg);
        color: #fff;
        margin-right: 3vw;
        margin-top: .1vw;
    }

    .hexIn {
        display: inline-block;
        width: 100%;
        height: 100%;
        text-align: center;
        overflow: hidden;
        transform: skewY(-30deg) rotate(60deg);
        background-color: rgba(12, 12, 13, 0.45);
        position: relative;
        img {
            width: 100%;
            position: absolute;
            left: 0;
            top: .5vw;
        }
    }

    .nameMsg {
        height: 2vw;
        display: block;
        text-align: center;
        width: 5vw;
        color: rgba(255, 255, 255, .7);
        i {
            font-style: normal;
            line-height: 2vw;
        }

        .num {
            font-size: 24px;
            font-weight: bold;
            margin-right: .5vw;
        }

        .name {
            font-size: 21px;
        }
    }
</style>
